"use client";

import { WorkSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedWorkSection from "../Components/GeneratedWorkSection";

const Work: FC<WorkSectionProps> = (props) => {
  return <GeneratedWorkSection {...props} />;
};

export default Work;
